module.exports = __webpack_public_path__ + "img/numicon.de781cab.png";